import { render } from "./06_TeamSection.vue?vue&type=template&id=5a1f8a8f&scoped=true"
import script from "./06_TeamSection.vue?vue&type=script&lang=js"
export * from "./06_TeamSection.vue?vue&type=script&lang=js"

import "./06_TeamSection.vue?vue&type=style&index=0&id=5a1f8a8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1f8a8f"]])

export default __exports__